export const EVIDENTIAL_DOCS_MATRIX_INTERMEDIARY = {
  title: `Residential Evidential Documents Matrix`,
  file_type: "PDF",
  file_size: "650KB",
  link_href: "/pdfs/Evidential_Docs_Matrix_2026.pdf",
  link_target: "_blank",
};
